import React, { useEffect, useRef, useState } from "react";
import Layout from "../../Layout";
import { Flex, Modal, Spin } from "antd";
import nodatafound from "../../assets/images/Svg/nodatafound.svg";
import PatientService from "../../Services/PatientService";
import PlusButton from "../../assets/images/Svg/plusIcon.svg";
import FilterIcon from "../../assets/images/Svg/FilterIcon.svg";
import AddFamilyMember from "./AddFamilyMember";
import FamilyList from "./FamilyList";

function FamilyMembers() {
  const [famList, setFamList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEdited, setIsEdited] = useState(false);
  const [familyMemModal, setFamilyMemModal] = useState(false);
  const [reload, setReload] = useState(false);
  const patJson = localStorage.getItem("patientData");
  const patObject = patJson ? JSON.parse(patJson) : null;
  const videoRef = useRef(null);

  useEffect(() => {
    getFamilyList();
  }, []);

  useEffect(() => {
    if (reload) {
      getFamilyList();
    }
  }, [reload]);

  // Re render the component if any family member data edited.
  useEffect(() => {
    getFamilyList();
  }, [isEdited]);

  const handlFamEdit = () => {
    setIsEdited(!isEdited);
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    // setIsCameraOpen(false);
  };

  const getFamilyList = async () => {
    setIsLoading(true);
    const payload = {
      parentPatientId: patObject.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  const handleAddFamModal = () => {
    setFamilyMemModal(!familyMemModal);
    stopCamera();
  };

  const handleReload = () => {
    setReload(true);
  };

  return (
    <Layout>
      <>
        <div className="flex justify-between items-center py-3 px-6 sticky top-3">
          <div className="">
            <h1 className="font-bold text-xl sm:text-sm">Family Members</h1>
          </div>
          <div className="flex gap-4">
            <div>
              <button
                onClick={handleAddFamModal}
                className="h-10 px-2 flex items-center gap-2 border border-brand-primaryColor rounded-md"
              >
                <img
                  src={PlusButton}
                  alt="Icon"
                  className="object-contain w-8 h-8"
                />
                <span className="text-[#189FAA] sm:text-xs">Add new</span>
              </button>
            </div>
          </div>
        </div>
        <div
          className={`${
            isLoading === false && famList?.length === 0
              ? "w-full flex justify-center items-center"
              : "overflow-y-scroll h-[20rem] scrollWidth"
          }`}
        >
          {isLoading && famList?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : famList?.length === 0 ? (
            <div className="flex flex-col items-center justify-center">
              <img
                src={nodatafound}
                alt="nodatafound"
                className="h-min w-min"
              />
              <p className="font-medium text-xl">No data Found!!!</p>
            </div>
          ) : (
            <div className="mt-6">
              <FamilyList
                handlFamEdit={handlFamEdit}
                stopCamera={stopCamera}
                videoRef={videoRef}
                famList={famList}
                isLoading={isLoading}
              />
            </div>
          )}
        </div>
      </>
      <Modal
        title="Add Family Member"
        open={familyMemModal}
        centered
        footer={null}
        onCancel={handleAddFamModal}
        width={window.innerWidth < 768 ? "100%" : "60%"}
        destroyOnClose
      >
        <AddFamilyMember
          handleReload={handleReload}
          videoRef={videoRef}
          onClose={handleAddFamModal}
        />
      </Modal>
    </Layout>
  );
}

export default FamilyMembers;
